import { useEffect, useState } from "react";

import { useAuth } from "common/hooks/useAuth";
import { pazienHistory } from "common/components/pazienHistory";

import { log } from "common/components/debug";

export const LogoutCallback = function({ timeout }) {
    const { logout, isAuthenticated } = useAuth();
    const [isLoggingOut, setIsLoggingOut] = useState(false);
    log("@@@ timeout ", timeout);

    useEffect(() => {
        // logout method triggers redux changes which can rerender this component.
        // If logout was triggered once, don't do it again.
        if (!isLoggingOut) {
            if (isAuthenticated() || timeout) {
                log("@@@ Logout trigger logout method");
                setIsLoggingOut(true);
                logout({ timeout });
                // shouldn't get here because logout unmounts this component anyway
                setIsLoggingOut(false);
            } else {
                log("@@@ Logout just navigate to login");
                pazienHistory.navigate("login", { replace: true, trigger: true });
            }
        }
    }, [logout, isAuthenticated, timeout, isLoggingOut]);
    
    return null;
};
